import { render, staticRenderFns } from "./LadderRankSidebar.vue?vue&type=template&id=21009f08&scoped=true"
import script from "./LadderRankSidebar.vue?vue&type=script&lang=js"
export * from "./LadderRankSidebar.vue?vue&type=script&lang=js"
import style0 from "./LadderRankSidebar.vue?vue&type=style&index=0&id=21009f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21009f08",
  null
  
)

export default component.exports